import { MART_CATEGORY_ACTION_TYPE, MartCategoryActions } from './martCategory-type';
import { MartCategoryState } from './martCategory-reducer';

export const martCategoryCreators = {
  setCatState: <KeyName extends keyof MartCategoryState>(key: KeyName, value: MartCategoryState[KeyName])
    : MartCategoryActions => ({
      type: MART_CATEGORY_ACTION_TYPE.SET_MART_CATEGORY_STATE,
      payload: { key, value }
    }),
  callMartCategoryTnc: () => ({
    type: MART_CATEGORY_ACTION_TYPE.CALL_MART_CATEGORY_TNC
  }),
};
